import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Alanditomumbaicab() {



const cardData = {
  keyword: " Alandi to Mumbai Cabs ",

headingDescription: "Velocity Cab provides reliable and comfortable Alandi to Mumbai cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Alandi to Mumbai convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Alandi to Mumbai cab travel.",

topPlaces: [
  
  {
    title: "Mount Mary Basilica",
    description: "Mount Mary Basilica in Bandra is one of Mumbai's most visited churches, attracting thousands of devotees and tourists every year. Travelers choosing an Innova Crysta on rent in Pune can comfortably visit this beautiful hilltop church while enjoying peaceful surroundings and panoramic views of the Arabian Sea. The church is especially popular during the annual Mount Mary Fair."
  },
  {
    title: "Taraporewala Aquarium",
    description: "Taraporewala Aquarium is one of India's oldest public aquariums and features an impressive collection of freshwater and marine species. Visitors hiring an Innova Crysta on rent in Pune can conveniently explore colorful fish, exotic aquatic life, and interactive exhibits. It is an excellent attraction for children, families, and marine life enthusiasts."
  },
  {
    title: "Worli Sea Face",
    description: "Worli Sea Face is a scenic waterfront promenade offering breathtaking views of the Arabian Sea and the iconic Bandra-Worli Sea Link. Travelers booking an Innova Crysta on rent in Pune can relax by the coastline, enjoy fresh sea breezes, and capture beautiful sunset photographs. It is a perfect destination for evening outings and peaceful walks."
  },
  {
    title: "Madh Island",
    description: "Madh Island is a peaceful coastal destination known for its quiet beaches, fishing villages, and scenic surroundings. Renting an Innova Crysta in Pune provides a comfortable journey for travelers looking to escape the city's hustle and bustle. The island is ideal for weekend getaways, beach walks, photography, and enjoying fresh seafood."
  },
  {
    title: "Kanheri Caves",
    description: "Kanheri Caves are ancient Buddhist rock-cut caves located within Sanjay Gandhi National Park in Mumbai. Travelers booking an Innova Crysta on rent in Pune can enjoy a comfortable road trip to explore these centuries-old caves, meditation halls, sculptures, and inscriptions. Surrounded by lush greenery, the site is perfect for history enthusiasts, photographers, and nature lovers seeking a unique cultural experience."
  },
  {
    title: "Girgaon Chowpatty",
    description: "Girgaon Chowpatty is one of Mumbai's most famous beaches, known for its lively atmosphere, delicious street food, and beautiful sunsets. Renting an Innova Crysta in Pune ensures a relaxing journey for families and groups planning a memorable beach outing. Visitors can enjoy local snacks, evening walks, and spectacular views of the Arabian Sea."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya",
    description: "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya is one of India's premier museums, housing remarkable collections of art, sculptures, manuscripts, and historical artifacts. Travelers choosing an Innova Crysta on rent in Pune can comfortably visit this iconic museum and discover India's rich cultural and artistic heritage in a beautifully preserved historic building."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is an architectural masterpiece dedicated to meditation and inner peace. Visitors traveling with an Innova Crysta on rent in Pune can enjoy a scenic drive to this magnificent monument near Gorai. The peaceful atmosphere, meditation center, and impressive golden dome make it one of Mumbai's most unique attractions."
  },
  {
    title: "Bandra Fort",
    description: "Bandra Fort, also called Castella de Aguada, is a historic Portuguese fort offering stunning views of the Arabian Sea and Bandra-Worli Sea Link. Travelers renting an Innova Crysta in Pune can comfortably visit this heritage site, explore its ancient walls, and enjoy excellent photography opportunities overlooking Mumbai's coastline."
  },
  {
    title: "Powai Lake",
    description: "Powai Lake is a picturesque destination surrounded by gardens, cafés, and modern city landmarks. Booking an Innova Crysta on rent in Pune allows families and groups to enjoy a relaxing road trip before spending time boating, walking along the lakeside, or dining at nearby restaurants. It is an excellent place to unwind during a Mumbai visit."
  }
],



services: [
{
name: "Cab Service in Alandi Pune",
description: "Cab service in Alandi Pune offers reliable transportation for local travel, airport transfers, and outstation journeys. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth rides across Pune and nearby cities. Professional drivers provide punctual pickup services from homes, temples, hotels, and residential areas around Alandi."
},
{
name: "Cab Service in Alandi Pune Contact Number",
description: "Cab service in Alandi Pune contact number helps passengers easily book taxis for city rides, airport transfers, and outstation travel. Professional drivers ensure safe journeys and timely pickup services. Vehicles are well maintained and suitable for comfortable travel."
},
{
name: "Alandi to Mumbai Cabs Service",
description: "Alandi to Mumbai cab service provides dependable transportation between Alandi in Pune and Mumbai city. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth expressway travel. Professional drivers provide safe and punctual journeys."
},
{
name: "Alandi to Mumbai Airport Cabs",
description: "Alandi to Mumbai Airport cab service offers reliable airport transfers between Alandi in Pune and Chhatrapati Shivaji Maharaj International Airport. Vehicles provide comfortable seating and luggage space suitable for airport travel."
},
{
name: "Cab Service in Wadmukhwadi",
description: "Cab service in Wadmukhwadi provides convenient transportation for local travel, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe and smooth rides across Pune."
},
{
name: "Cab Service in Charholi Budruk",
description: "Cab service in Charholi Budruk offers dependable transportation for daily commuting, airport transfers, and long-distance journeys. Vehicles are comfortable and suitable for both city rides and expressway travel."
},
{
name: "24 Hours Cab Service in Charholi",
description: "24 hours cab service in Charholi provides round-the-clock transportation for passengers needing reliable rides anytime. Vehicles are available for airport transfers, outstation trips, and local travel."
},
{
name: "Charholi to Mumbai Cab Service",
description: "Charholi to Mumbai cab service offers dependable transportation between Pune’s Charholi area and Mumbai city. Comfortable vehicles and experienced drivers ensure safe expressway journeys."
},
{
name: "Moshi to Mumbai Cab Service",
description: "Moshi to Mumbai cab service provides reliable transportation between Pune’s Moshi area and Mumbai city. Vehicles are comfortable and suitable for long-distance expressway travel."
},
{
name: "Moshi to Mumbai Cab Fare",
description: "Moshi to Mumbai cab fare service offers transparent pricing for passengers traveling between Moshi and Mumbai. Affordable taxi options ensure comfortable travel with professional drivers."
},
{
name: "Moshi to Mumbai Airport Cab Fare",
description: "Moshi to Mumbai Airport cab fare service provides cost-effective airport transportation between Moshi in Pune and Mumbai Airport terminals. Vehicles ensure comfortable seating and safe highway travel."
},
{
name: "Moshi to Mumbai Round Trip Cab Fare",
description: "Moshi to Mumbai round trip cab fare service offers economical pricing for return travel between Moshi and Mumbai. Spacious vehicles ensure comfortable travel for families and business travelers."
},
{
name: "Cab Service in Moshi",
description: "Cab service in Moshi provides reliable transportation for local rides, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe travel experiences."
},
{
name: "Cheapest Cab Service in Moshi",
description: "Cheapest cab service in Moshi offers economical transportation for passengers seeking budget-friendly travel options. Vehicles provide comfortable seating and reliable travel across Pune and nearby cities."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides dependable transportation for city rides, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe travel experiences."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides reliable airport transportation from Pune to Mumbai Airport terminals. Vehicles offer comfortable seating and safe expressway travel."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab service offers dependable intercity transportation between Pune and Mumbai. Comfortable vehicles and experienced drivers ensure smooth highway travel."
},
{
name: "Cab Service in Charholi Budruk Pune",
description: "Cab service in Charholi Budruk Pune provides convenient transportation for local travel, airport transfers, and long-distance journeys. Vehicles ensure comfortable and reliable travel experiences."
},
{
name: "Cab Service in Alandi",
description: "Cab service in Alandi provides reliable taxi services for local travel, airport transfers, and outstation trips. Comfortable vehicles and experienced drivers ensure safe and smooth journeys."
},
{
name: "Alandi to Mumbai Cab",
description: "Alandi to Mumbai cab service offers dependable transportation between Pune and Mumbai. Vehicles such as sedan, Ertiga, and Innova ensure comfortable expressway travel."
},
{
name: "Alandi to Mumbai Taxi",
description: "Alandi to Mumbai taxi service provides reliable intercity transportation between Alandi in Pune and Mumbai city. Professional drivers ensure safe and comfortable highway journeys."
}
],

tableData: [
["Cab Service in Alandi Pune","Cab Service in Alandi Pune Contact Number"],
["Alandi to Mumbai Cabs Service","Alandi to Mumbai Airport Cabs"],
["Cab Service in Wadmukhwadi","Cab Service in Charholi Budruk"],
["24 Hours Cab Service in Charholi","Charholi to Mumbai Cab Service"],
["Moshi to Mumbai Cab Service","Moshi to Mumbai Cab Fare"],
["Moshi to Mumbai Airport Cab Fare","Moshi to Mumbai Round Trip Cab Fare"],
["Cab Service in Moshi","Cheapest Cab Service in Moshi"],
["Cab Service in Pune","Pune to Mumbai Airport Cab"],
["Pune Mumbai Cab","Cab Service in Charholi Budruk Pune"],
["Cab Service in Alandi","Alandi to Mumbai Cab"],
["Alandi to Mumbai Taxi","Cab Service in Alandi Pune"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who frequently travel from Alandi to Mumbai via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Alandi to Mumbai cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Alandi to Mumbai cab service operates 24 hours a day. Whether you need an early morning airport transfer, corporate travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Alandi to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Alandi",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, temples, and residential areas across Alandi and nearby areas like Dighi, Moshi, Bhosari, and Vishrantwadi."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Alandi to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Alandi to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Alandi to Mumbai with professional drivers and comfortable vehicles." },
  { question: "Where is Alandi located?", answer: "Alandi is a town in Pune district of Maharashtra situated on the banks of the Indrayani River and is known as an important pilgrimage place associated with Sant Dnyaneshwar." },
  { question: "Is Alandi to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Alandi to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Alandi to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Alandi and Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, temples, and residential societies across Alandi." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Alandi to Mumbai cab services online or through phone booking." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and other major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vivek Jadhav",
    feedback:
      "I booked a cab with Velocity Cabs for my Alandi to Mumbai trip, and everything was managed perfectly. The driver arrived on time, the ride was comfortable, and we reached safely without any hassle.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Patil",
    feedback:
      "Our journey from Alandi to Mumbai with Velocity Cabs was pleasant and stress-free. The cab was neat, the driver was courteous, and the service was reliable throughout the trip.",
    rating: 5
  }
];





































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Alandi to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Alandi to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis including Innova, Ertiga, and Sedan cabs for airport transfers, Mumbai Airport, Wadmukhwadi, Charholi, Moshi, and other nearby destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Alandi to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Alandi to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Alandi to Mumbai cab with Velocity Cabs. Affordable one way, round trip & airport drop taxis including Innova, Ertiga & Sedan for Mumbai Airport, Wadmukhwadi, Charholi & Moshi." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/29.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Alanditomumbaicab;